import React from 'react';

import './style.scss';

const GroupIcon = () => {
  return (
    <svg className="uni-avatar__img--default" viewBox="0 0 32 32" version="1.1">
      <g fill="none" fillRule="evenodd">
        <g>
          <path
            d="M17.8184521,25.8127247 C17.9258851,26.2697569 17.9878411,33.1185969 18,33.7684809 L0,
            33.7684809 C0.0185692578,32.7759713 0.153283608,25.7231407 0.388755442,25.16168 C0.964772741,
            23.4173233 2.47171811,22.0545909 4.49621728,21.2500166 C5.76994649,22.1631027 7.33248638,
            22.6999943 9.02017758,22.6999943 C10.7071282,22.6999943 12.2689276,22.1631027 13.5433973,
            21.2500166 C15.8027856,22.1482919 17.4186444,23.7419345 17.8184521,25.8127247 Z M3.0958557,
            14.9243219 C3.0958557,11.6526151 5.74773028,9 9.02017758,9 C12.2918843,9 14.9437589,
            11.6526151 14.9437589,14.9243219 C14.9437589,18.1967692 12.2918843,20.8486438 9.02017758,
            20.8486438 C5.74773028,20.8486438 3.0958557,18.1967692 3.0958557,14.9243219 Z"
            fillRule="evenodd"
            fillOpacity="0.6"
            fill="#85929E"
          />
          <path
            stroke="#45515E"
            strokeWidth="2"
            d="M18.798047,25.6125353 C18.8688037,
            25.9737581 18.9049573,27.2479196 18.9462121,29.7870848 C18.9663427,31.0260884 19.0006113,
            33.7917981 18.999825,33.7497747 L19.0188844,34.7684809 L-1.0188844,34.7684809 L-0.999825025,
            33.7497747 C-0.990197208,33.2351768 -0.979391755,32.7078587 -0.964263291,32.0605439 C-0.941577908,
            31.0898847 -0.915657665,30.1451979 -0.886402498,29.2700278 C-0.79482598,26.5305105 -0.714128107,
            25.2057898 -0.560811696,24.8481162 C0.103131229,22.8374938 1.79616424,21.2469917 4.12689528,
            20.3207151 L4.63471477,20.118898 L5.07884028,20.437274 C6.21832412,21.2541249 7.58418348,
            21.6999943 9.02017758,21.6999943 C10.4552797,21.6999943 11.8204782,21.2542322 12.960998,
            20.4371137 L13.4051368,20.1189132 L13.9128442,20.3207647 C16.5411949,21.3657301 18.3416061,
            23.2472656 18.8003195,25.6231555 L18.798047,25.6125353 Z M2.0958557,14.9243219 C2.0958557,
            11.1000939 5.19568195,8 9.02017758,8 C12.8440665,8 15.9437589,11.1002278 15.9437589,
            14.9243219 C15.9437589,18.7489201 12.8443029,21.8486438 9.02017758,21.8486438 C5.19544553,
            21.8486438 2.0958557,18.7490539 2.0958557,14.9243219 Z"
          />
        </g>
        <g>
          <path
            d="M31.8184521,25.8127247 C31.9258851,26.2697569 31.9878411,33.1185969 32,33.7684809 L14,
            33.7684809 C14.0185693,32.7759713 14.1532836,25.7231407 14.3887554,25.16168 C14.9647727,
            23.4173233 16.4717181,22.0545909 18.4962173,21.2500166 C19.7699465,22.1631027 21.3324864,
            22.6999943 23.0201776,22.6999943 C24.7071282,22.6999943 26.2689276,22.1631027 27.5433973,
            21.2500166 C29.8027856,22.1482919 31.4186444,23.7419345 31.8184521,25.8127247 Z M17.0958557,
            14.9243219 C17.0958557,11.6526151 19.7477303,9 23.0201776,9 C26.2918843,9 28.9437589,
            11.6526151 28.9437589,14.9243219 C28.9437589,18.1967692 26.2918843,20.8486438 23.0201776,
            20.8486438 C19.7477303,20.8486438 17.0958557,18.1967692 17.0958557,14.9243219 Z"
            fillRule="evenodd"
            fillOpacity="0.6"
            fill="#85929E"
          />
          <path
            stroke="#45515E"
            strokeWidth="2"
            d="M32.798047,25.6125353 C32.8688037,25.9737581 32.9049573,
            27.2479196 32.9462121,29.7870848 C32.9663427,31.0260884 33.0006113,33.7917981 32.999825,
            33.7497747 L33.0188844,34.7684809 L12.9811156,34.7684809 L13.000175,33.7497747 C13.0098028,
            33.2351768 13.0206082,32.7078587 13.0357367,32.0605439 C13.0584221,31.0898847 13.0843423,
            30.1451979 13.1135975,29.2700278 C13.205174,26.5305105 13.2858719,25.2057898 13.4391883,
            24.8481162 C14.1031312,22.8374938 15.7961642,21.2469917 18.1268953,20.3207151 L18.6347148,
            20.118898 L19.0788403,20.437274 C20.2183241,21.2541249 21.5841835,21.6999943 23.0201776,
            21.6999943 C24.4552797,21.6999943 25.8204782,21.2542322 26.960998,20.4371137 L27.4051368,
            20.1189132 L27.9128442,20.3207647 C30.5411949,21.3657301 32.3416061,23.2472656 32.8003195,
            25.6231555 L32.798047,25.6125353 Z M16.0958557,14.9243219 C16.0958557,11.1000939 19.195682,
            8 23.0201776,8 C26.8440665,8 29.9437589,11.1002278 29.9437589,14.9243219 C29.9437589,
            18.7489201 26.8443029,21.8486438 23.0201776,21.8486438 C19.1954455,21.8486438 16.0958557,
            18.7490539 16.0958557,14.9243219 Z"
          />
        </g>
        <g>
          <path
            d="M27.2680222,26.482926 C27.4052977,27.0669116 27.4844636,35.8182071 27.5,36.6486144 L4.5,
            36.6486144 C4.52372739,35.3804077 4.69586239,26.3684575 4.99674307,25.6510355 C5.73276517,
            23.4221353 7.65830648,21.6808661 10.2451665,20.6527989 C11.8727094,21.8195201 13.8692882,
            22.5055483 16.0257825,22.5055483 C18.1813305,22.5055483 20.176963,21.8195201 21.8054521,
            20.6527989 C24.6924483,21.8005952 26.7571567,23.8369163 27.2680222,26.482926 Z M8.45581561,
            12.5699668 C8.45581561,8.38945266 11.844322,5 16.0257825,5 C20.2062967,5 23.5948031,
            8.38945266 23.5948031,12.5699668 C23.5948031,16.7514273 20.2062967,20.1399337 16.0257825,
            20.1399337 C11.844322,20.1399337 8.45581561,16.7514273 8.45581561,12.5699668 Z"
            fillRule="evenodd"
            fill="#85929E"
          />
          <path
            stroke="#45515E"
            strokeWidth="2"
            d="M28.2479899,26.2844791 C28.3320194,26.713217 28.3796339,
            28.3853511 28.4313077,31.5657875 C28.4570161,33.1480946 28.5008095,36.6825268 28.499825,
            36.6299083 L28.5188844,37.6486144 L3.4811156,37.6486144 L3.50017497,36.6299083 C3.51246977,
            35.9727628 3.52626842,35.2993734 3.54558774,34.4727408 C3.57455447,33.2333163 3.60765022,
            32.0271113 3.64499729,30.9098714 C3.75870425,27.5083208 3.86495952,25.7640547 4.04717593,
            25.3374717 C4.8676029,22.8529677 6.96918415,20.8786593 9.87584452,19.7234975 L10.383664,
            19.5216804 L10.8277895,19.8400564 C12.3306273,20.9173814 14.1323955,21.5055483 16.0257825,
            21.5055483 C17.9180245,21.5055483 19.7189194,20.9175234 21.2230528,19.8398961 L21.6671916,
            19.5216956 L22.174899,19.7235471 C25.4512409,21.0261373 27.6833106,23.3587813 28.2498895,
            26.2933568 L28.2479899,26.2844791 Z M7.45581561,12.5699668 C7.45581561,7.83686041 11.2923447,
            4 16.0257825,4 C20.7584396,4 24.5948031,7.83702606 24.5948031,12.5699668 C24.5948031,
            17.3035464 20.758747,21.1399337 16.0257825,21.1399337 C11.2920373,21.1399337 7.45581561,
            17.303712 7.45581561,12.5699668 Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default GroupIcon;



// WEBPACK FOOTER //
// ./src/avatars/__partials/group-icon.jsx